<template>
  <a-layout class="layout hall-layout">
    <div class="head">
      <hall-head/>
    </div>
    <div class="main">
      <div class="headBg"><img :src="require('@/assets/serviceHall/serviceHallBackground.png')"></div>
      <div class="router">
        <router-view />
      </div>
    </div>
    <hall-footer/>
  </a-layout>
</template>

<script>
import HallHead from '@/views/serviceHall/components/HallHead.vue'
import HallFooter from '@/views/serviceHall/components/HallFooter.vue'
export default {
  components: { HallHead, HallFooter },
  name: 'ServiceHallLayout'
}
</script>

<style scoped lang="less">
.hall-layout {
  height: 100vh;
  background-color: #FAFCFF;
  display: flex;
  flex-direction: column;
  .head{
    width: 100%;
    background-color: #2379F4;
    height: 55px;
  }
  .main{
    flex: 1;
    position: relative;
    .headBg{
      width: 100%;
      height: 290px;
      img{
        width: 100%;
        height: 290px;
      }
    }
    .router{
      position: absolute;
      top: 45px;
      transform: translateX(-50%);
      left: 50%;
      width: 1200px;
    }
  }
}
</style>
